import { t } from "../i18n";

const NAME_PATTERN = "^[a-zA-Z\\s\\-'.]+$";

const RULES = {
	firstName: { pattern: NAME_PATTERN, required: true, placeholder: "firstName" },
	lastName: { pattern: NAME_PATTERN, required: true, placeholder: "lastName" },
	fullName: { pattern: NAME_PATTERN, required: true, placeholder: "fullName" },
	email: {
		pattern: "^[a-zA-Z0-9._%\\-\\+]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
		placeholder: "email",
	},
	phone: { pattern: "[0-9]+", required: true },
	address: { required: true, placeholder: "address" },
	state: { required: true },
	country: { required: true, placeholder: "country" },
	city: { required: true, placeholder: "city" },
	zip_code: { required: true, placeholder: "zip_code" },
};

export function formValidation() {
	const fields = document.querySelectorAll(
		".sdk-form input:not(.hidden-input), .sdk-form select",
	);

	fields.forEach((field) => {
		const rule = RULES[field.name];

		if (!rule) {
			return;
		}
		if (rule.pattern) {
			field.pattern = rule.pattern;
		}
		if (rule.required) {
			field.required = true;
		}
		if (rule.title) {
			field.title = rule.title;
		}
		if (rule.placeholder) {
			field.placeholder = t("formsPlaceholders")[rule.placeholder];
		}
	});
}
